const servers = {
    "portal-dotia.dev.doubledot.es": "https://sandboxbackcliente1.dotia.es",
    "portal-uax.dev.doubledot.es": "https://sandbox-uax.dotia.es",
    "portal-comillas.dev.doubledot.es": "https://sandbox-comillas.dotia.es",
    "portal-uc3m.dev.doubledot.es": "https://sandbox-uc3m.dotia.es",
    "portal-uc3m-dev.dotia.es": "https://sandbox-uc3m.dotia.es",
    "portal-uva.dev.doubledot.es": "https://sandbox-uva.dotia.es",
    "portal-uib.dev.doubledot.es": "https://sandbox-uib.dotia.es",
    "localhost:8080": "https://sandbox-uc3m.dotia.es",
    "localhost:8081": "https://sandbox-uc3m.dotia.es",
    "192.168.1.184:8080": "https://sandbox-uc3m.dotia.es",
    //PRODUCCCION
    "empleo.uax.es": "https://backoffice.empleo.uax.es",
    "portal.uvaempleo.com": "https://backoffice.uvaempleo.com",
    "doipcandidats.fueib.org": "https://doipgestio.fueib.org/",
    "portal-uc3m.dotia.es" : "https://gestionoye.uc3m.es",
    "empleoypracticas.uc3m.es" : "https://gestionoye.uc3m.es"
}

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js